import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/VehicleBasicStageOne'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class VehicleBasicStageOneStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "VehicleBasicStageOneStore",
			variables: true,
		})
	}
}

export async function load_VehicleBasicStageOne(params) {
  await initClient()

	const store = new VehicleBasicStageOneStore()

	await store.fetch(params)

	return {
		VehicleBasicStageOne: store,
	}
}
